import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ChaptersFocusModeService } from '@app/components/chapters-page/services/chapters-focus-mode.service';
import { SlideDTO } from 'src/app/model/slideDTO.model';

@Component({
    selector: 'app-slide-text-video',
    templateUrl: './slide-text-video.component.html',
    styleUrls: ['./slide-text-video.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlideTextVideoComponent implements OnInit {

  @Input() public slideData: SlideDTO;
  @Input() public requiredToWatchVideo: boolean;
  @Input() public maxVideoHeight: number;

  @Output() public videoWatched: EventEmitter<void> = new EventEmitter();
  @Output() public videoStarted: EventEmitter<void> = new EventEmitter();

  constructor(public readonly chaptersFocusModeService: ChaptersFocusModeService) { }

  ngOnInit() {
  }

  public toggleFullscreen(): void {
    if (this.chaptersFocusModeService.isFocusMode) {
      return;
    }

    this.chaptersFocusModeService.toggleFocusMode();
  }

  public emitVideoWatched(): void {
    this.videoWatched.emit();
  }

  public emitVideoStarted(): void {
    this.videoStarted.emit();
  }
}
